import styled from 'styled-components';

import {HeaderTitle} from '../../shared-components/custom-features/app-element/Title.js';
import {GradientGimmickBar} from '../../shared-components/mixin/gradientGimmick.js';
import {ScrollBar} from '../../shared-components/mixin/scroll/scrollBar.js';
import {PageWrapper} from '../page/Page.js';

export const ModalBody = styled(ScrollBar)`
    height: 100%;

    grid-area: modalBody;
    @-moz-document url-prefix() {
        overflow-y: auto;
        scrollbar-color: var(--scroll-bar-thumb-moz) var(--scroll-bar-thumb);
    }
    overflow-y: auto;
    padding: var(--modal-padding);

    &:has(${PageWrapper.toString()}) {
        padding: 0px;
    }
`;
export const ModalTitle = styled(HeaderTitle)`
    padding: 0;
`;
export const ModalLabel = styled.h2`
    color: var(--default-text-color);
    font-size: var(--modal-title-label-size);
    margin: 0 0 8px;
    padding: 0;
`;
export const ModalHeader = styled.div`
    grid-area: modalHeader;
    position: relative;
    z-index: 3;

    background: var(--container-background-color-100);
    box-shadow: var(--container-shadow-color-100);
    padding: 12px var(--modal-padding);

    display: flex;
    justify-content: space-between;
    align-items: center;
    border-radius: var(--modal-border-radius) var(--modal-border-radius) 0 0;
`;
export const ModalFooter = styled.div`
    position: relative;
    z-index: 20;
    grid-area: modalFooter;

    padding: var(--space-md) var(--modal-padding) 0px;
    background: var(--container-background-color-100);
    box-shadow: var(--container-shadow-color-100);
`;

export const GimmikContainer = styled.div`
    height: var(--modal-gimmick-container);
    width: 100%;
    border-radius: 0 0 var(--modal-border-radius) var(--modal-border-radius);
    z-index: var(--z-index-modal-gimmick-bar);
    position: relative;

    grid-area: modalGimmik;
    overflow: hidden;
    display: block;
    background: var(--container-background-color-100);
`;

export const FooterGimmickBar = styled(GradientGimmickBar)`
    height: var(--modal-gimmick-bar-height);
    z-index: var(--z-index-modal-gimmick-bar);
    width: 100%;
`;
